export default __webpack_public_path__ + "static/media/image_icon.a1b32465.svg";